import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import Joyride from "react-joyride";
import CompanyStatusCheck from "./CompanyStatusCheck";
import Search from "./Search";
import { FormControl } from "react-bootstrap";

import Index from "./Index";
import { fetchTemplates } from "../actions/index";
import TemplatesIndexTourSteps from "./tours/TemplatesIndexTourSteps";

export class TemplatesIndex extends Index {
  static propTypes = {
    fetchTemplates: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    templates: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchTemplates(
      this.serialize(newQueries)
    );
    this.props.history.push(`/templates${this.serialize(newQueries)}`);
  }

  categoryOptions() {
    if (
      !this.props.templates.meta ||
      this.props.templates.meta.categories === undefined
    ) {
      return "";
    }
    let categories = this.props.templates.meta.categories;
    return super.categoryOptions(categories);
  }

  renderTemplates() {
    if (!this.props.templates.data && !this.props.templates.meta) {
      return (
        <tr>
          <td colSpan={12}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.templates.data.length == 0) {
      return (
        <tr>
          <td colSpan={12}>
            <div className="well well-lg text-center">
              You have no templates.&nbsp;
              <Link to={`/templates/new`} >
                Click here to create one.
              </Link>
            </div>
          </td>
        </tr>
      );
    }

    return this.props.templates.data.map(template => {
      return (
        <tr key={template.id}>
          <td>
            <Link to={`/templates/${template.id}`} >
              <strong>{template.name}</strong>
            </Link>
          </td>
          <td>{template.email_template_category_name}</td>
          <td>{template.subject}</td>
          <td>{template.source}</td>
          <td className="text-right">{template.delivered_count}</td>
          <td className="text-right">{template.opened_count}</td>
          <td className="text-right">{template.clicked_count}</td>
          <td className="text-right">{template.unsubscribed_count}</td>
          <td className="text-right">{template.complained_count}</td>
          <td className="text-right">{template.bounced_count}</td>
          <td className="text-right">{template.dropped_count}</td>
          <td className="text-right">
            <Link to={`/templates/${template.id}`}
              className="btn btn-sm btn-default template_edit"
            >
              Edit
            </Link>
          </td>
        </tr>
      );
    });
  }

  startTour() {
    this.setState({
      steps: TemplatesIndexTourSteps.tourSteps(),
      startTour: true
    });
  }

  render() {
    let count = 0;
    if (this.props.templates.meta) {
      count = this.props.templates.meta.count;
    }
    return (
      <div className="templates_index">
        <CompanyStatusCheck history={this.props.history} />
        <Joyride
          run={this.state.startTour}
          continuous={true}
          steps={this.state.steps}
          showSkipButton={true}
          showProgress={true}
          scrollToSteps={false}
          callback={this.tourCallback.bind(this)}
        />
        <div className="row">
          <h1>
            Emails
            <button
              bsStyle="default"
              className="btn btn-sm btn-primary help_icon_smaller"
              onClick={this.startTour.bind(this)}
            >
              ?
            </button>
            <Link to={`/templates/new`}
              className="btn btn-primary pull-right new_template_btn m-l-10"
            >
              Add New Template
            </Link>
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
            <div className="pull-right col-sm-3">
              <FormControl
                componentClass="select"
                type="select"
                className="input"
                wrapperClassName="p-0"
                addonBefore={"Filter by Category"}
                name="category_id"
                onChange={this.handleFilterCategory.bind(this)}
              >
                <option value="">All Categories</option>
                {this.categoryOptions()}
              </FormControl>
            </div>
          </h1>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`template_name ${this.indicateSorting("name")}`}
                  data-sort="name"
                  onClick={this.handleOrder.bind(this)}
                >
                  Name
                </th>
                <th
                  className={`template_category ${this.indicateSorting(
                    "email_template_categories.name"
                  )}`}
                  data-sort="email_template_categories.name"
                  onClick={this.handleOrder.bind(this)}
                >
                  Category
                </th>
                <th
                  className={`template_subject ${this.indicateSorting(
                    "subject"
                  )}`}
                  data-sort="subject"
                  onClick={this.handleOrder.bind(this)}
                >
                  Subject
                </th>
                <th
                  className={`template_source ${this.indicateSorting(
                    "source"
                  )}`}
                  data-sort="source"
                  onClick={this.handleOrder.bind(this)}
                >
                  Source
                </th>
                <th
                  className={`text-right email_stats_delivered ${this.indicateSorting(
                    "delivered_count"
                  )}`}
                  data-sort="delivered_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Delivered
                </th>
                <th
                  className={`text-right email_stats_opened ${this.indicateSorting(
                    "opened_count"
                  )}`}
                  data-sort="opened_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Opens
                </th>
                <th
                  className={`text-right email_stats_clicked ${this.indicateSorting(
                    "clicked_count"
                  )}`}
                  data-sort="clicked_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Clicks
                </th>
                <th
                  className={`text-right email_stats_unsubscribed ${this.indicateSorting(
                    "unsubscribed_count"
                  )}`}
                  data-sort="unsubscribed_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Unsubs
                </th>
                <th
                  className={`text-right email_stats_spam_report ${this.indicateSorting(
                    "complained_count"
                  )}`}
                  data-sort="complained_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Spam R.
                </th>
                <th
                  className={`text-right email_stats_bounced ${this.indicateSorting(
                    "bounced_count"
                  )}`}
                  data-sort="bounced_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Bounces
                </th>
                <th
                  className={`text-right email_stats_failed ${this.indicateSorting(
                    "dropped_count"
                  )}`}
                  data-sort="dropped_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Failures
                </th>
                <th className="text-right" />
              </tr>
            </thead>
            <tbody>{this.renderTemplates()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { templates: state.templates.all };
}

export default connect(
  mapStateToProps,
  { fetchTemplates }
)(TemplatesIndex);
